const getDefaultState = function() {
  return {
    group: {},
    groupList: {
      'a5a4243c40d74147b006191889bd039b' : {  // 岳麓论坛
        noSign: true,
        name: '开幕式|岳麓论坛',
        // poster: 'https://sn202108-1305501521.cos.ap-shanghai.myqcloud.com/202409081200428661919.jpg',
        theme:'AI 领航 畅想湘江',
        desc: '',
        host: {
          name: '',
          position: ['']
        },
        organizer: [],
        undertaker: [],
        coOrganizer: [],
        zcOrganizer:[],
        users: [
          
        ],
        contact: {
          name:'',
          phone:''
        },
        schedule: [
          {
            date: '',
            title: '开幕式(09:00—10:40)',
            titleType: 'center',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '',
            title: '',
            type: '',
            host: {},
            tableTalk: false,
            people: [
              {
                name:'主  持：'
              },
              {
                name: '毛伟明',
                position: ['湖南省委副书记、省长']
              },
              {
                name: '',
                position: ['· 观看2025互联网岳麓大会宣传片']
              },
              {
                name: '',
                position: ['· 湖南省委常委、长沙市委书记吴桂英致辞']
              },
              {
                name: '',
                position: ['· 湖南省委书记沈晓明讲话并宣布开幕']
              },
              {
                name: '',
                position: ['(以下环节由湖南广播电视台主持人万欣主持）']
              },
              {
                name: '',
                position: ['· 发布全球研发中心城市及大学生创新创业年度报告']
              },
              {
                name: '',
                position: ['· 发布一批在湘AI行业模型']
              },
              {
                name: '',
                position: ['· 中国工程院院士、湖南大学电气与信息工程学院教授、机器人视觉感知与控制技术国家工程研究中心主任王耀南作主旨演讲']
              },
              {
                name: '',
                position: ['· 中兴通讯股份有限公司董事长方榕作主旨演讲']
              },
              {
                name: '',
                position: ['· 香港科技大学教授、XbotPark机器人基地发起人李泽湘作主旨演讲']
              },
              {
                name: '',
                position: ['· 长江商学院院长、长江商学院金融学教授李海涛作主旨演讲']
              },

            ],
          },
          {
            date: '',
            title: '岳麓论坛(10:45—11:30)',
            titleType: 'center',
            type: '',
            host: {

            },
            tableTalk: true,
            people: [],
          },

          {
            date: '',
            title: '',
            type: '',
            host: {
            },
            tableTalk: false,
            people: [
              {
                name: '主                    题：',
                position: ['']
              },
              {
                name: 'AI潮流下的新创业'
              },
              {
                name: '主持人：',
                position:[]
              },
              {
                name: '倪正东  ',
                position: ['清科集团创始人、董事长，清科控股董事长兼 CEO']
              },
              {
                name: '嘉   宾：',
                position: []
              },
              {
                name: '周超男',
                position: ['润泽科技发展有限公司董事长']
              },
              {
                name: '祝铭明',
                position: ['灵伴科技有限公司创始人、首席执行官']
              },
              {
                name: '李舟军',
                position: ['北京航空航天大学计算机学院信息安全系主任']
              },
              {
                name: '曾 光',
                position: ['中科云谷科技有限公司总经理']
              },
              {
                name: '顾善植',
                position: ['湖南汇视威智能科技有限公司董事长']
              },
            ],
          },
        ],
      },
      "b67a34cc52ad4429b1111c727e315436" : {  // 大学生创新创业
        noSign: true,
        name: '大学生创新创业',
        // poster: 'https://sn202108-1305501521.cos.ap-shanghai.myqcloud.com/202409081200428661919.jpg',
        theme:'青年创未来 智汇新湖南',
        desc: '',
        time: '2025年9月15日14:00-17:00',
        location: '世界计算·长沙智谷多功能会议中心3楼',
        host: {
          name: '',
          position: ['']
        },
        zdOrganizer:[
          "湖南省支持大学生创业工作协调机制办公室",
          "湖南省委宣传部",
          "湖南省教育厅",
          "湖南省科技厅",
          "湖南省财政厅",
          "湖南省人力资源和社会保障厅",
          "共青团湖南省委",
          "湖南湘江新区管理委员会"
        ],
        organizer: [
          "2025互联网岳麓大会组委会",
          "长沙市支持大学生创业工作专班办公室",
          "湖南财信金融控股集团有限公司"
        ],
        undertaker: [
          "湖南湘江新区民政和社会保障局",
          "湘江科学城（长沙）（岳麓山大学科技城）管理委员会",
          "新湘会"
        ],
        coOrganizer: [
          "清科集团",
          "湖南麓山科技投资有限公司",
          "湖南省人工智能协会"
        ],
        zcOrganizer:[],
        users: [

        ],
        contact: {
          name:'',
          phone:''
        },
        schedule: [
          {
            date: '2025年9月15日',
            title: '',
            type: '',
            host: {},
            tableTalk: false,
            people: [
              {
                name: '主 持：',
                position: ['']
              },
              {
                name: '王先民',
                position: ['湖南湘江新区(长沙高新区)党工委委员、管委会副主任']
              }
            ],
          },
          {
            date: '2025年9月15日',
            title: '14:00-14:20 签到和暖场',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:20-14:25 观看湖南省大学生创新创业宣传片',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:25-14:30 长沙市委副书记、湖南湘江新区（长沙高新区）党工委书记，岳麓区委书记谭勇致欢迎辞',
            type: '',
            host: {
              name: '',
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:30-14:40 湖南省委副秘书长、省支持大学生创业工作协调机制办公室主任王学武讲话',
            type: '',
            host: {
              name: '',
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:40-14:50 湖南省天使投资联盟成立仪式',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            ceremonyItems: [
              {
                itemName: '上台嘉宾：倪正东 清科集团创始人、董事长清科控股董事长兼CEO',
                participants: ''
              },
              {
                itemName: '周建元 湖南财信金融控股集团有限公司党委书记、董事长',
                participants: ''
              },
              {
                itemName: '龚虹嘉 嘉道资本创始人、董事长',
                participants: ''
              },
              {
                itemName: '谢冀勇 长沙投资控股集团有限公司党委书记、董事长',
                participants: ''
              },
              {
                itemName: '李 丰 峰瑞资本创始合伙人',
                participants: ''
              },
              {
                itemName: '龚国旺 湖南湘江新区国有资本投资有限公司党支部书记、董事长',
                participants: ''
              },
              {
                itemName: '吴哲辉 新湘会创始人兼会长，BlueFriday Limited创始人',
                participants: ''
              },
              {
                itemName: '李 岳 湖南麓山科技投资有限公司总经理',
                participants: ''
              }
            ],
          },
          {
            date: '2025年9月15日',
            title: '主持：专业主持人 子嘉',
            type: '',
            host: {
              name: '',
              position: []
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:50-15:10 主题演讲：《科创时代的大学生创业》',
            type: '',
            host: {
              name: '倪正东',
              position: ['清科集团创始人、董事长，清科控股董事长兼CEO']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:10-15:30 主题演讲：《AI时代的创业机会》',
            type: '',
            host: {
              name: '李 丰',
              position: ['峰瑞资本创始合伙人']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:30-16:00 创业故事分享',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [
              {
                name: '戴跃锋',
                position: ['水羊股份（300740）董事长']
              },
              {
                name: '陈方明',
                position: ['博雷顿（HK1333）董事长']
              }
            ],
          },
          {
            date: '2025年9月15日',
            title: '16:00-16:10 "新湘青年"App 发布',
            type: '',
            host: {
              name: '吴哲辉',
              position: ['新湘会创始人兼会长']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '16:10-17:00 圆桌论坛：《岳麓论"创"：两代大学生创业面对面》',
            type: '',
            host: {
              name: '欧阳宇',
              position: ['湖南找广科技有限公司CEO']
            },
            tableTalk: true,
            people: [
              {
                name: '刘健伟',
                position: ['湖南西子健康集团股份有限公司董事长']
              },
              {
                name: '屈阳超',
                position: ['湖南西瓜创想科技有限公司CEO']
              },
              {
                name: '彭士平',
                position: ['湖南享梦游网络科技有限公司董事长']
              },
              {
                name: '肖湘江',
                position: ['湖南省超能机器人技术有限公司董事长']
              },
              {
                name: '李佳璇',
                position: ['湖南食小助科技有限责任公司总经理']
              },
              {
                name: '何宜轩',
                position: ['岳阳氢云致行新能源有限责任公司总经理']
              },
              {
                name: '陈思为',
                position: ['深圳市智动未来科技有限公司CEO']
              }
            ],
          },
        ],
      },
      "09904e69cd9a4040bbd88b0a5e18f82f" : {  // AI+创新生态
        noSign: true,
        name: 'AI+创新生态',
        // poster: 'https://sn202108-1305501521.cos.ap-shanghai.myqcloud.com/202409081200428661919.jpg',
        theme:'长江AI·岳麓论道',
        desc: '',
        time: '2025年9月15日下午14:00-16:30',
        location: '梅溪湖国际文化艺术中心小剧院',
        host: {
          name: '',
          position: ['']
        },
        zdOrganizer:[
          "湖南省科学技术厅、湖南省财政厅",
        ],
        organizer: [
          "2025互联网岳麓大会组委会"
        ],
        undertaker: [
          "长江商学院",
          "湖湘汇",
          "长沙高新技术产业开发区长沙信息产业片区管理办公室"
        ],
        coOrganizer: [
          "长江商学院高层管理教育（CKEE）",
          "长江商学院湖南校友会",
          "长江商学院 CEO 联盟",
          "长江商学院数智经济学会",
          "长江商学院智能制造学会"
        ],
        zcOrganizer:[],
        users: [

        ],
        contact: {
          name:'',
          phone:''
        },
        schedule: [
          {
            date: '2025年9月15日',
            title: '主持人',
            type: '',
            host: {
              name: '帅军',
              position: ['湖南湘江新区(长沙高新区)党工委委员、管委会副主任']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:00-14:05 组委会领导致欢迎词',
            type: '',
            host: {
              name: '何朝晖',
              position: ['湖南湘江新区(长沙高新区)党工委副书记、管委会主任，岳麓区委副书记、区长']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:05-14:10 长江商学院领导致辞',
            type: '',
            host: {
              name: '李海涛',
              position: ['长江商学院院长、长江商学院金融学教授、杰出院长讲席教授、长江商学院教育发展基金会名誉理事长']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:10-14:35《AI营销：变革、挑战与机遇》',
            type: '',
            host: {
              name: '李 洋',
              position: ['哥伦比亚大学商学院博士；长江商学院市场营销学副教授；MBA项目副院长；高层管理教育项目学术主任']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:35-14:55《主动思考-自动执行-迭代进化：AI Agent驱动的业务全链路增长革新》',
            type: '',
            host: {
              name: '赵旭隆',
              position: ['Maketingforce迈富时（02556.HK）董事长、上海科创金融研究院院董、长江商学院数智经济学会会长、上海市人工智能协会副会长']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:55-15:15《AIGC 2.0时代：构建双模驱动下的AI创意新范式》',
            type: '',
            host: {
              name: '吴太兵',
              position: ['万兴科技创始人、董事长']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:15-15:35《AI制造-重塑生产范式》',
            type: '',
            host: {
              name: '迟景朝',
              position: ['天鹰资本董事长、长江商学院智能制造学会执行会长、长江商学院CEO联盟秘书长']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:35-15:40 换场准备（主持人引导）',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:40-16:30 圆桌论坛：AI+创新生态的"共生"与"共赢"',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '话题 1：AI 时代的创新和生态发展',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '话题 2: AI+产业建设，湖南的机遇与挑战',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '话题 3: AI 如何重塑中国企业全球化路径',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '主持人：李新宇 拓维信息创始人、董事长',
            type: '',
            host: {
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '圆桌嘉宾：',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [
              {
                name: '姚劲波',
                position: ['58同城CEO']
              },
              {
                name: '徐少春',
                position: ['金蝶集团董事会主席兼CEO']
              },
              {
                name: '周超男',
                position: ['润泽智算科技集团股份有限公司董事长']
              },
              {
                name: '姚 颂',
                position: ['国际先进技术应用推进中心(深圳)主任']
              },
              {
                name: '陈湘宇',
                position: ['创梦天地董事会主席、首席执行官、创始人']
              },
              {
                name: '何恩培',
                position: ['传神语联创始人、董事长']
              }
            ],
          },
        ],
      },
      "83544effc0d24f478a08fb43ba829d47" : {  // AI+文化
        noSign: true,
        name: 'AI+文化',
        // poster: 'https://sn202108-1305501521.cos.ap-shanghai.myqcloud.com/202409081200428661919.jpg',
        theme:'AI+文化',
        desc: '',
        time: '2025年9月15日14:00-16:10',
        location: '马栏山视频文创产业园创智园1号演播厅',
        host: {
          name: '',
          position: ['']
        },
        zdOrganizer:[],
        organizer: [
          "2025互联网岳麓大会组委会"
        ],
        undertaker: [
          "马栏山(长沙)视频文创园管理委员会",
          "湖南湘江新区文化旅游产业链办公室"
        ],
        coOrganizer: [],
        zcOrganizer:[],
        users: [

        ],
        contact: {
          name:'',
          phone:''
        },
        schedule: [
          {
            date: '2025年9月15日',
            title: '14:00-14:05 领导致辞',
            type: '',
            host: {
              name: '周志凯',
              position: ['长沙市人民政府党组成员、副市长']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:05-14:10 领导讲话',
            type: '',
            host: {
              name: '刘 学',
              position: ['湖南省委宣传部副部长（兼）、省委网信办主任']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:10-14:25 主题演讲1：AI+音视频技术创新标准：以极致音视频体验，助力湖南成为全球音视频产业高地',
            type: '',
            host: {
              name: '燕 兴',
              position: ['世界超高清视频产业联盟（UWA）副秘书长，华为技术有限公司产业发展副总裁']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:25-14:40 主题演讲2：AI+微短剧的发展趋势',
            type: '',
            host: {
              name: '乐 力',
              position: ['红果短剧总编辑']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:40-14:55 主题演讲3："人工智能+"构筑影视制作新业态',
            type: '',
            host: {
              name: '涂永峰',
              position: ['马栏山音视频实验室主任']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:55-15:10 主题演讲4：以科技为舟，载文化远航',
            type: '',
            host: {
              name: '方 菲',
              position: ['芒果数智总经理']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:10-15:25 主题演讲5：打造智能终端平台，建立从模型到Agent，从云侧到端侧的生态体系',
            type: '',
            host: {
              name: '李 璟',
              position: ['阶跃星辰联合创始人、副总裁']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:25-15:40 主题演讲6：AIGC打造数字文娱新生态',
            type: '',
            host: {
              name: '苑朋飞',
              position: ['橙煌映画总经理、中影年年联合创始人']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:40-15:55 主题演讲7：从"中国文化"到"世界表达"：AIGC驱动的文化创新实践',
            type: '',
            host: {
              name: '张 铮',
              position: ['万兴科技副总裁']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:55-16:10 主题演讲8：四项创新举措助力文旅设备更新',
            type: '',
            host: {
              name: '姚项军',
              position: ['京东方科技集团执行副总裁，京东方艺云科技有限公司董事长']
            },
            tableTalk: false,
            people: [],
          },
        ],
      },
      "8056400d7533406a8152b8e874ff920e" : {  // AI+智能网联
        noSign: true,
        name: 'AI+智能网联',
        // poster: 'https://sn202108-1305501521.cos.ap-shanghai.myqcloud.com/202409081200428661919.jpg',
        theme:'AI与智能网联汽车产业融合发展论坛',
        desc: '',
        time: '2025年9月15日下午14:00-17:00',
        location: '梅溪湖艺术博物馆中庭',
        host: {
          name: '',
          position: ['']
        },
        zdOrganizer:[
          "湖南省科学技术厅",
          "湖南省工业和信息化厅",
          "湖南湘江新区管理委员会"
        ],
        organizer: [
          "2025互联网岳麓大会组委会"
        ],
        undertaker: [
          "湖南湘江新区管理委员会科技创新和产业促进局（大学科技园办公室）",
          "长沙高新技术产业开发区长沙信息产业片区管理办公室",
          "湖南湘江智能科技创新中心有限公司",
          "中汽院智能网联汽车检测中心（湖南）有限公司",
          "湖南金蝶软件科技有限公司"
        ],
        coOrganizer: [
          "长沙市智能汽车产业促进会"
        ],
        zcOrganizer:[],
        users: [

        ],
        contact: {
          name:'',
          phone:''
        },
        schedule: [
          {
            date: '2025年9月15日',
            title: '14:00-14:05 专业主持人开场，介绍到场嘉宾',
            type: '',
            host: {
            },
            tableTalk: false,
            people: [
              {
                name: '主 持：',
                position: ['']
              },
              {
                name: '任明',
                position: ['湖南湘江新区（长沙高新区）党工委委员、管委会副主任，岳麓区人民政府副区长']
              }
            ],
          },
          {
            date: '2025年9月15日',
            title: '14:05-14:10 长沙市人民政府副市长康镇麟上台致辞',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:10-14:15 智能网联典型应用场景颁奖',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            ceremonyItems: [
              {
                itemName: '第一批请王德志、彭迟平同志颁奖',
                participants: ''
              },
              {
                itemName: '第二批请王友志同志颁奖',
                participants: ''
              },
              {
                itemName: '第三批请刘云超同志颁奖',
                participants: ''
              }
            ],
          },
          {
            date: '2025年9月15日',
            title: '14:15-14:20 中国信息通信研究院副院长魏亮讲话',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:20-14:35 院士演讲：中国工程院院士，清华大学车辆与运载学院教授、智能绿色车辆与交通全国重点实验室主任李克强',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '',
            title: '主持人：王靖轩',
            titleType: 'center',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:40-14:45 发布长沙市智能网联汽车“车路云一体化”试点场景建设目标（陶凤翔副局长发布）',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:45-14:50 智驾"封神榜"第二届IVISTA（C-IAC）湖南全民智能辅助驾驶挑战赛结果暨国家智能网联汽车质量检验检测中心（湖南）创新能力发布（姜维同志发布）',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:50-16:15 主题演讲：AI与智能网联汽车产业融合发展新路径',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:50-15:02 惠州市德赛西威汽车电子股份有限公司副总裁陈俊峰《AI时代下的智慧物流新未来》',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:02-15:14 云控智行科技有限公司CT0杨轩《车路云一体化基础设施服务多场景的建设思路与实践》',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:14-15:26 万集科技副总裁智能网联事业部总经理高鑫《高价值应用场景驱动车路云一体化规模化建设》',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:26-15:38 新石器慧通（北京）科技有限公司创始人兼CEO余恩源《用人工智能打造智慧物流基础设施》',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:38-15:50 华为政务一网通研发副总裁张妮《大模型赋能智能网联价值呈现》',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:50-16:02 央广智能网联汽车数字媒体（上海）有限公司特聘专家黄东《创建中国湖南（高速+长株潭）智驾之省"车路云听"方案（建议）》',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '16:02-16:14 金蝶中国助理总裁、高端制造事业部总经理郭旭光《AI+管理，汽车制造新动能》',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '16:15-17:00 圆桌论坛：智能网联汽车典型应用场景在长株潭的探索',
            type: '',
            host: {
              name: '姚丹亚'
            },
            tableTalk: true,
            people: [
              {
                name: '陶凤翔',
                position: ['长沙市工业和信息化局党组成员、副局长']
              },
              {
                name: '宋长征',
                position: ['株洲市工业和信息化局党组书记、局长']
              },
              {
                name: '刘大可',
                position: ['湘潭市工业和信息化局党委委员、副局长']
              },
              {
                name: '彭照坤',
                position: ['上海哈啰普惠科技有限公司联合创始人、高级副总裁']
              },
              {
                name: '周清',
                position: ['九识智能联合创始人生态合作负责人']
              },
              {
                name: '陈洪标',
                position: ['长沙行深智能科技有限公司副总裁']
              }
            ],
          },
        ],
      },
      "8e6044db3ebd4a559565bfbf388352c1" : {  // AI+工业互联网
        noSign: true,
        name: 'AI+工业互联网',
        // poster: 'https://sn202108-1305501521.cos.ap-shanghai.myqcloud.com/202409081200428661919.jpg',
        theme:'实数融合·智谱新篇',
        desc: '',
        time: '2025年9月15日14:00-16:30',
        location: '长沙梅溪湖金茂精选酒店三楼宴会厅3厅',
        host: {
          name: '',
          position: ['']
        },
        zdOrganizer:[
          "湖南省工业和信息化厅",
          "湖南湘江新区管理委员会"
        ],
        organizer: [
          "2025互联网岳麓大会组委会"
        ],
        undertaker: [
          "湖南湘江新区管理委员会科技创新和产业促进局",
          "长沙高新技术产业开发区长沙信息产业片区管理办公室",
          "湖南省工业互联网发展研究中心",
          "中科云谷科技有限公司",
          "湖南华菱云创数智科技有限公司",
          "湖南省软件行业协会"
        ],
        coOrganizer: [],
        zcOrganizer:[],
        users: [

        ],
        contact: {
          name:'',
          phone:''
        },
        schedule: [
          {
            date: '2025年9月15日',
            title: '领导致辞、讲话及主旨演讲',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '主持人：王 玮 湖南湘江新区党工委委员、管委会副主任',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:00-14:05 领导致欢迎词',
            type: '',
            host: {
              name: '郑 平',
              position: ['市人民政府党组成员、副市长']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:05-14:15 领导讲话',
            type: '',
            host: {},
            tableTalk: false,
            people: [
              {
                name: '陈 晖',
                position: ['省工业和信息化厅党组成员、副厅长']
              },
              {
                name: '谢小鹏',
                position: ['省通信管理局党组书记、局长']
              }

            ],
          },
          {
            date: '2025年9月15日',
            title: '14:15-14:40 主旨演讲：用自主可信计算AI产品构建工业互联网安全底座',
            type: '',
            host: {
              name: '沈昌祥',
              position: ['中国工程院院士']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '发布仪式、主题演讲及圆桌论坛',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '主持人：专业主持人',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:40-14:50 同舟AI供需对接平台发布仪式',
            type: '',
            host: {
              name: '邱文瀛',
              position: ['中国工业互联网研究院智能化研究所人工智能部主任']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:50-15:10 主题演讲1：工业高质量数据集助力工业互联网和人工智能双向赋能',
            type: '',
            host: {
              name: '田 野',
              position: ['中国工业互联网研究院副总工程师']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:10-15:30 主题演讲2：发展具身智能人形机器人，打造先进制造业新高地',
            type: '',
            host: {
              name: '曾 光',
              position: ['中科云谷科技有限公司总经理']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:30-15:50 主题演讲3：大模型系统赋能工业实战',
            type: '',
            host: {
              name: '彭立彪',
              position: ['北京智谱华章科技股份有限公司聆心智能团队技术负责人']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:50-16:30 圆桌论坛：《AI与工业互联网在工业领域的融合之道》',
            type: '',
            host: {
              name: '唐 琎',
              position: ['中南大学自动化学院教授']
            },
            tableTalk: true,
            people: [
              {
                name: '徐克付',
                position: ['北京大学大数据分析与应用技术国家工程实验室特聘研究员']
              },
              {
                name: '郑 键',
                position: ['湖南华菱云创数智科技有限公司总经理']
              },
              {
                name: '陈 超',
                position: ['阿里云计算有限公司公共云事业部副总裁']
              },
              {
                name: '刘圣祥',
                position: ['蔚来汽车制造物流运营中心高级总监']
              }
            ],
          },
        ],
      },
      "4e2d65640b5b4caeb3873109744342bc" : {  // AI+营商环境
        noSign: true,
        name: 'AI+营商环境',
        // poster: 'https://sn202108-1305501521.cos.ap-shanghai.myqcloud.com/202409081200428661919.jpg',
        theme:'AI+营商环境',
        desc: '',
        time: '2025年9月15日14:00-16:45',
        location: '长沙梅溪湖金茂精选酒店三楼宴会厅1、2厅',
        host: {
          name: '',
          position: ['']
        },
        zdOrganizer:[
          "湖南省发展和改革委员会"
        ],
        organizer: [
          "2025互联网岳麓大会组委会"
        ],
        undertaker: [
          "长沙市发展和改革委员会",
          "长沙市优化营商环境协调事务中心",
          "湖南湘江新区管理委员会经济发展局",
          "长沙高新技术产业开发区长沙信息产业片区管理办公室"
        ],
        coOrganizer: [
          "长沙市移动互联网产业联盟"
        ],
        zcOrganizer:[],
        users: [

        ],
        contact: {
          name:'',
          phone:''
        },
        schedule: [
          {
            date: '',
            title: '主持人：专业主持人',
            type: '',
            titleType: 'center',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '',
            title: '领导致辞及讲话',
            type: '',
            titleType: 'center',
            host: {
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:00-14:05 市领导致辞',
            type: '',
            host: {
              name: '钱丽霞',
              position: ['长沙市人民政府副市长']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:05-14:10 省发改委领导讲话',
            type: '',
            host: {
              name: '黄东红',
              position: ['省发改委党组书记、主任']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '权威信息发布',
            type: '',
            titleType: 'center',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:10-14:20 发布湖南省优化营商环境改革创新"十佳"案例',
            type: '',
            host: {
              name: '刘风华',
              position: ['省优化办主任']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:20-14:30 发布《2025长沙数字营商环境白皮书》',
            type: '',
            host: {
              name: '喻志军',
              position: ['长沙市发改委党组书记、主任']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '专题演讲',
            type: '',
            titleType: 'center',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:30-14:45 主题演讲1：《营造一流营商环境，激发产业升级与经济发展活力》',
            type: '',
            host: {
              name: '韩永文',
              position: ['湖南省原省委常委、副省长，中国国际经济交流中心原副理事长']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:45-15:00 主题演讲2：《"芯"动能与新生态：国产算力如何筑基数字营商环境》',
            type: '',
            host: {
              name: '吴宗友',
              position: ['海光信息技术股份有限公司副总裁']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:00-15:15 主题演讲3：《从"能办"到"智办"：AI+政务服务如何规范化系统性迭代演进》',
            type: '',
            host: {
              name: '仇 轶',
              position: ['国家发改委营商环境发展促进中心副主任']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:15-15:30 主题演讲4：《数字经济时代营商环境改革进行时：最佳实践与湖南机遇》',
            type: '',
            host: {
              name: '张 湧',
              position: ['上海交通大学上海高级金融学院副院长，兼任上海金融与发展实验室副主任']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:30-15:45 主题演讲5：《培养有机生态土壤，孕育全球科创企业》',
            type: '',
            host: {
              name: '周 奇',
              position: ['金沙江联合资本管理合伙人、全球化创新企业联盟发起人兼秘书长']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '圆桌论坛',
            type: '',
            titleType: 'center',
            host: {
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:45-16:45 圆桌论坛：《数智赋能，共建企业有感的优质营商生态》',
            type: '',
            host: {
              name: '于 勃',
              position: ['普华永道中国综合商务咨询服务主管合伙人']
            },
            tableTalk: true,
            people: [
              {
                name: '马晓白',
                position: ['国务院发展研究中心企业研究所跨国企业研究室主任、研究员']
              },
              {
                name: '杨 涛',
                position: ['湖南麒麟信安科技股份有限公司董事长']
              },
              {
                name: '朱文辉',
                position: ['长沙安牧泉智能科技有限公司董事长、国家973计划封装首席科学家、国家特聘专家']
              },
              {
                name: '张 宇',
                position: ['行云集团高级副总裁']
              },
              {
                name: '冀 菲',
                position: ['北京电子数智科技有限责任公司副总裁（公共及政府事务）']
              }
            ],
          },
        ],
      },
      "d530a44915e74cce81c6fe160ee3c5f8" : {  // AI+城市治理
        noSign: true,
        name: 'AI+城市治理',
        // poster: 'https://sn202108-1305501521.cos.ap-shanghai.myqcloud.com/202409081200428661919.jpg',
        theme:'AI时代的中国城市治理模式创新',
        desc: '',
        time: '2025年9月15日14:00-16:30',
        location: '国家网络安全产业园1栋4楼多功能厅',
        host: {
          name: '',
          position: ['']
        },
        zdOrganizer:[],
        organizer: [
          "2025互联网岳麓大会组委会"
        ],
        undertaker: [
          "湘江新区行政审批服务局",
          "北京大学城市治理研究院",
          "湖南大学公共管理学院",
          "北京大学长沙计算与数字经济研究院"
        ],
        coOrganizer: [],
        zcOrganizer:[],
        users: [

        ],
        contact: {
          name:'',
          phone:''
        },
        schedule: [
          {
            date: '2025年9月15日',
            title: '开场环节（14:00-14:20）',
            type: '',
            host: {
              name: '彭利芝',
              position: ['湖南湘江新区（长沙高新区）党工委委员、岳麓区人大常委会党组书记、主任']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:00-14:20 领导致辞',
            type: '',
            host: {},
            tableTalk: false,
            people: [
              {
                name: '周述东',
                position: ['湖南省数据局党组成员、副局长']
              },
              {
                name: '汪卫斌',
                position: ['湖南大学党委常委、副校长']
              },
              {
                name: '周春晖',
                position: ['长沙市人民政府党组成员、副市长']
              }
            ],
          },
          {
            date: '2025年9月15日',
            title: '主题演讲（14:20-15:50）',
            type: '',
            host: {
              name: '广电专业主持人'
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:20-14:35 主题演讲1：人工智能和城市',
            type: '',
            host: {
              name: '张振山',
              position: ['联合国人居署中国办公室高级顾问']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:35-14:50 主题演讲2：长沙市智慧视觉体系和视频产业体系建设情况报告',
            type: '',
            host: {
              name: '吴 进',
              position: ['长沙市数据局党组成员、副局长']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:50-15:05 主题演讲3：AI时代中国城市治理的整合与出海',
            type: '',
            host: {
              name: '沈体雁',
              position: ['北京大学政府管理学院教授、北京大学城市治理研究院执行院长、首都发展研究院副院长']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:05-15:20 主题演讲4：政策智能与数智赋能城市治理',
            type: '',
            host: {
              name: '张 楠',
              position: ['清华大学公共管理学院教授、清华大学计算社会科学与国家治理实验室副主任']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:20-15:35 主题演讲5：生成式人工智能：风险与治理',
            type: '',
            host: {
              name: '谭海波',
              position: ['湖南大学公共管理学院教授、院长']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:35-15:50 主题演讲6：AI时代城市建设的工匠精神',
            type: '',
            host: {
              name: '付胜龙',
              position: ['大汉控股集团董事长']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '圆桌论坛（15:50-16:30）',
            type: '',
            host: {},
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:50-16:30 圆桌论坛：《人工智能赋能中国城市治理的"生态化"和"走出去"》',
            type: '',
            host: {
              name: '谷 浩',
              position: ['湖南大学公共管理学院副教授、国际交流合作办公室主任']
            },
            tableTalk: true,
            people: [
              {
                name: '翟宝辉',
                position: ['中国社会科学院大学城乡建设经济系原系主任、住房和城乡建设部政策研究中心原副主任、二级研究员']
              },
              {
                name: '吴 进',
                position: ['长沙市数据局党组成员、副局长']
              },
              {
                name: '耿德红',
                position: ['北京大学城市治理研究院副院长兼秘书长']
              },
              {
                name: '徐 莹',
                position: ['湖南大学公共管理学院教授、副院长']
              },
              {
                name: '王文婷',
                position: ['北京大学先进制造与机器人学院研究员']
              },
              {
                name: '贺鸿富',
                position: ['上海爱数信息技术股份有限公司董事长、总裁']
              }
            ],
          },
        ],
      },
      "cee3654463464872b9ac522b5a4c28a7" : {  // AI+新材料
        noSign: true,
        name: 'AI+新材料',
        // poster: 'https://sn202108-1305501521.cos.ap-shanghai.myqcloud.com/202409081200428661919.jpg',
        theme:'AI+新材料',
        desc: '',
        time: '2025年9月15日14:00-17:25',
        location: '株洲制造名城国际学术交流中心四楼动力谷厅',
        host: {
          name: '',
          position: ['']
        },
        zdOrganizer:[
          "湖南省科技厅",
          "株洲市委",
          "株洲市人民政府"
        ],
        organizer: [
          "2025互联网岳麓大会组委会",
          "株洲高新区管理委员会",
          "株洲市科技局"
        ],
        undertaker: [
          "株洲高新区创新创业服务中心"
        ],
        coOrganizer: [],
        zcOrganizer:[
          "湖南兴湘投资控股集团有限公司",
          "中南大学粉末冶金国家重点实验室"
        ],
        users: [

        ],
        contact: {
          name:'',
          phone:''
        },
        schedule: [
          {
            date: '2025年9月15日',
            title: '揭牌仪式（14:00-14:25）',
            type: '',
            host: {},
            tableTalk: false,
            people: [
              {
                name: '主持人：',
                position: ['专业主持人']
              },
              {
                name: '',
                position: ['1.株洲（长沙）科创基地授牌；']
              },
              {
                name:'授牌人：',
                position: ['曹慧泉']
              },
              {
                name:'接牌人：',
                position: ['邬凌云']
              },
              {
                name:'',
                position: ['2.株洲市委书记曹慧泉致欢迎词；']
              },
              {
                name:'',
                position: ['3.湖南省新材料产业协会理事长覃事彪讲话；']
              },
              {
                name:'',
                position: ['4.湖南省科技厅厅长朱皖讲话；']
              },
              {
                name:'',
                position: ['5.中南兴湘成果转化平台及中试基地启动、项目签约仪式；']
              },
              {
                name:'（1）启动仪式：',
                position: []
              },
              {
                name:' ',
                position: ['启动领导：贺柳、郭学益，刘亚亮、刘智勇']
              },
              {
                name:'（2）项目签约',
                position: []
              },
              {
                name:' ',
                position: ['中南大学汞监测治理与资源回收、新型耐火涂层材料中试项目；']
              },
              {
                name:' ',
                position: ['签约人：李寒波、李海龙、张利军、黄继军']
              },
              {
                name:'',
                position: ['6.株洲“AI+新材料”专家顾问聘任仪式']
              },
              {
                name:' ',
                position: ['专家顾问：张利军、曹荣根、胡望宇、管震']
              },
              {
                name:' ',
                position: ['颁发领导：阳望平']
              },
              {
                name:'',
                position: ['7.株洲“AI+新材料”联合创新中心（筹）揭牌']
              },
              {
                name:' ',
                position: ['揭牌领导：朱皖、贺柳、曹慧泉、陈恢清、邬凌云']
              }

            ],
          },
          {
            date: '2025年9月15日',
            title: '主旨演讲（14:30-16:10）',
            type: '',
            host: {
              name: '主持人：专业主持人'
            },
            tableTalk: false,
            people: [],
            ceremonyItems: [
              {
                itemName: '14:30-14:50 主题演讲：《时代新材科技创新体系及AI应用场景》',
                participants: '彭超义 中车时代新材副总经理'
              },
              {
                itemName: '14:50-15:10 主题演讲：《数据+AI赋能新材料开发》',
                participants: '张利军 中南大学教授'
              },
              {
                itemName: '15:10-15:30 主题演讲：《AI在工业垂直领域的应用》',
                participants: '管 震 广东智用人工智能研究院院长'
              },
              {
                itemName: '15:30-15:50 主题演讲：《引领材料研发进入人工智能时代》',
                participants: '曹荣根 上海鸿之微科技股份有限公司董事长'
              },
              {
                itemName: '15:50-16:10 主题演讲：《人工智能与量子技术在新材料领域的产业应用》',
                participants: '马 寅 北京玻色量子科技有限公司创始人'
              }
            ],
          },
          {
            date: '2025年9月15日',
            title: '圆桌对话（16:15-17:25）',
            type: '',
            host: {

            },
            tableTalk: false,
            people: [
              {
                name: '',
                position: ['对话主题：AI 时代下株洲新材料产业的机遇与挑战']
              },
              {
                name: '',
                position: ['主持人：中车时代新材副总经理彭超义']
              },
              {
                name: '对话人：',
                position: ['']
              },
              {
                name: '彭超义',
                position: ['中车时代新材副总经理']
              },
              {
                name: '邬凌云',
                position: ['株洲高新区党工委书记、天元区委书记']
              },
              {
                name: '张利军',
                position: ['中南大学粉末冶金国家重点实验室教授']
              },
              {
                name: '管 震',
                position: ['广东智用人工智能应用研究院院长']
              },
              {
                name: '曹荣根',
                position: ['上海鸿之微科技股份有限公司董事长']
              },
              {
                name: '傅仲宏',
                position: ['达晨财智创业投资管理有限公司主管合伙人']
              },
              {
                name: '王彧弋',
                position: ['天元智能科学研究院院长']
              }
            ],
          },
        ],
      },
      "6d354390bd304ccab26464bce7b1f68d" : {  // AI+数字教育
        noSign: true,
        name: 'AI+数字教育',
        // poster: 'https://sn202108-1305501521.cos.ap-shanghai.myqcloud.com/202409081200428661919.jpg',
        theme:'AI+数字教育',
        desc: '',
        time: '2025年9月15日下午',
        location: '湘潭大学数学与计算科学学院负一楼报告厅',
        host: {
          name: '',
          position: ['']
        },
        zdOrganizer:[],
        organizer: [
          "2025互联网岳麓大会组委会、湘潭大学",
        ],
        undertaker: [
          "湘潭大学创业学院",
          "湘潭大学卓越工程师学院",
          "湖南国家应用数学中心",
          "湖南韶峰应用数学研究院"
        ],
        coOrganizer: [],
        zcOrganizer:[],
        users: [

        ],
        contact: {
          name:'',
          phone:''
        },
        schedule: [
          {
            date: '2025年9月15日',
            title: '14:30-14:50 开幕式',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:30-14:35 嘉宾介绍',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:35-14:40 湘潭大学领导致辞',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:40-14:45 湘潭市领导致辞',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '14:45-14:50 韶峰数智教育平台发布仪式',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [],
          },

          {
            date: '2025年9月15日',
            title: '14:50-15:35 韶峰大讲堂报告：人工智能与科学教育协同的新定位与新范式',
            type: '',
            host: {
              name: '徐宗本',
              position: ['中国科学院院士、西安交通大学教授']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '15:35-16:25 主题报告：AI+数字教育',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [
            ],
          },
          {
            date: '2025年9月15日',
            title: '15:35-16:00 主题报告："联"动智慧，"育"见未来——人工智能助推教育应用新范式',
            type: '',
            host: {
              name: '周 智',
              position: ['湖南联通党委书记、总经理，高级工程师']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '16:00-16:25 主题报告：人工智能技术浪潮希沃的思考与实践',
            type: '',
            host: {
              name: '黄柏林',
              position: ['视源股份（未来教育集团）副总裁、AI研究院院长']
            },
            tableTalk: false,
            people: [],
          },
          {
            date: '2025年9月15日',
            title: '产品介绍（16:25-16:35）',
            type: '',
            host: {
              name: ''
            },
            tableTalk: false,
            people: [
              {
                name:'',
                position: ['韶峰数智教育平台介绍']
              }
            ],
          },
          {
            date: '2025年9月15日',
            title: '16:40-17:30 圆桌论坛：AI视阈下的大学生创新创业人才培养',
            type: '',
            host: {
              name: '葛 飞',
              position: ['湘潭大学副校长、教授']
            },
            tableTalk: true,
            people: [
              {
                name: '徐宗本',
                position: ['中国科学院院士、西安交通大学教授']
              },
              {
                name: '周 智',
                position: ['湖南联通党委书记、总经理，高级工程师']
              },
              {
                name: '黄柏林',
                position: ['视源股份（未来教育集团）副总裁、AI研究院院长']
              },
              {
                name: '黄 乐',
                position: ['第十四届全国人大代表，高级工程师，湘潭宏大真空技术股份有限公司总经理']
              }
            ],
          },
        ],
      },
    },
    groupArray: []
  }
}

const state = getDefaultState()

const mutations = {
  SET_GROUP(state, group) {
    state.group = group
  },
  SET_GROUPARRAY(state, list) {
    state.groupArray = list
  }
}
export default {
  namespaced: true,
  state,
  mutations
}

